export enum PriceMethodType {
    None = 0,
    Batch  = 1,
    FDACost = 2,
    Public = 3,
    ContractPricelist = 4,
}
